import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { GridItemCount } from '../../../GridPeripherals/GridItemCount';
import { ProductListingMobileHeaderTitle } from '../ProductListingMobileHeaderTitle';
import './ProductListingMobileHeader.scss';

type Props = {
  headerText: string | undefined;
  totalItems: number;
  hideCount?: boolean;
  belowHeader?: ReactNode;
};

export const ProductListingMobileHeader: React.FC<Props> = ({
  headerText,
  totalItems,
  hideCount,
  belowHeader
}) => (
  <div
    className={classNames('ProductListingMobileHeader', {
      'ProductListingMobileHeader--centered': hideCount
    })}
  >
    <ProductListingMobileHeaderTitle headerText={headerText} />

    {belowHeader}

    {!hideCount && (
      <GridItemCount className="ProductListingMobileHeader__count" count={totalItems} />
    )}
  </div>
);
